import * as React from "react";
import { styled } from "@mui/material";
import ReportProblemOutlinedIcon from "@mui/icons-material/ReportProblemOutlined";

//region [[ Styles ]]

const MasterClinicWarningView = styled("div")({
  color: "#FFFFFF",
  background: "#4247C9",
  padding: 8,
  borderRadius: 6,
  marginBottom: 10,
  display: "flex",
  alignItems: "top",
  gap: 12,
});

//endregion [[ Styles ]]

//region [[ Props ]]

//endregion [[ Props ]]

//region [[ Functions ]]
//endregion [[ Functions ]]

export const MasterClinicWarning = () => {
  return (
    <MasterClinicWarningView>
      <ReportProblemOutlinedIcon />
      You are about to change settings for the master clinic, which might affect
      all children clinics.
      <br />
      Are you sure you want to proceed?
    </MasterClinicWarningView>
  );
};
